import React, { useState, useEffect} from 'react';
import { makeStyles } from "@material-ui/core/styles";
import {Card,CardContent,Box, Tooltip} from "@material-ui/core";
import NumberFormat from 'react-number-format';

const useStyles = makeStyles((theme) => ({
    card:{
      height:4+'rem',
      width:100,     
      color:'white',
      marginRight:'.5em',
    },
    card2:{
      height:4.5+'rem',
      width:100,     
      color:'white',
      marginRight:'.5em',
    },
    titulo:{        
        textAlign:'center',
        marginTop:'-.2rem',
        fontSize:'1.1rem',
        fontWeight:600
    },
    tituloColor:{
        textAlign:'center',
        marginTop:'.2rem',
        fontSize:'1.1rem',
        fontWeight:600
    },
    subtitulo:{        
        textAlign:'center',
        marginTop:'-1.4rem',
        fontSize:'.8rem',
    },
    subtituloCard:{       
        textAlign:'center',
        marginTop:'.1rem',
        fontSize:'.9rem',
    },
}));


export default function CardPerfil({listTotal, dtoRegistro}){
    const classes = useStyles();
    const [valor,setValor]=useState([])

    useEffect(()=>{
        if (dtoRegistro.length !== 0 ) {
      
            ///let filtro = listTotal.distritos.filter((distrito)=> distrito.Dto === dtoRegistro.DtId)
            //console.log(filtro[0]);
            setValor({...dtoRegistro, PercepBuena: dtoRegistro.PerpBuena , 
                PercepInde: dtoRegistro.PerpIndec, PercepMala: dtoRegistro.PerpMala })
        }
        else{
            setValor(listTotal)
        }
    },[listTotal, dtoRegistro])

    function generarCards(mensaje,datos, leyendaTp ){
        return( 
        <CardContent style={{margin:0, padding:0}}>
            <div className={classes.tituloColor} 
                style={{color:'white'}} 
            >                
                <NumberFormat value={datos} displayType={'text'}  thousandSeparator={true}/>
            </div>
            <Tooltip title={leyendaTp}>
                <p className={classes.subtituloCard} >
                    {mensaje}
                </p>
            </Tooltip>
        </CardContent>
        )
    }

    function generarCards2(mensaje,datos,auxColor){
        return( 
        <CardContent>
            <Card className={classes.tituloColor} 
                style={{backgroundColor:auxColor,color:'white'}} 
            >                
                <NumberFormat value={datos} displayType={'text'}  thousandSeparator={true}/>
            </Card>
            <p className={classes.subtituloCard} >
                {mensaje}
            </p>
        </CardContent>
        )
    }
  
    return (         
    <Box display="flex" flexDirection="row" mb={1}  >   
       { valor.length!==0 ?
        <Box display="flex" flexDirection="row">                                    
            <Card className={classes.card} style={{backgroundColor:'#FFA318'}}>
                {generarCards('18 a 25',valor.Edad18_25, 'Edad 18 a 25')}
            </Card>
            <Card className={classes.card} style={{backgroundColor:'#B406D8'}}>
                {generarCards('26 a 35',valor.Edad26_35, 'Edad 26 a 35' )}
            </Card>
            <Card className={classes.card} style={{backgroundColor:'#C52363'}}>
                {generarCards('36 a 45', valor.Edad36_45, "Edad 36 a 45")}
            </Card>   
            <Card className={classes.card} style={{backgroundColor:'#4BAC7D'}}>
                {generarCards('46 a 100', valor.Edad46_100, 'Edad 46 a 100')}
            </Card>            
        </Box> 
        :null}  
        { valor.length!==0 ?
        <Box display="flex" flexDirection="row">                                    
             <Card className={classes.card} style={{backgroundColor:'#C52363'}}>
                {generarCards('P. Mala', valor.PercepMala,"Percepción Mala")}
            </Card>  
            
            <Card className={classes.card} style={{backgroundColor:'#FFA318'}}>
                {generarCards('P. Indecisa',valor.PercepInde, "Percepción Indecisa" )}
            </Card>
            <Card className={classes.card} style={{backgroundColor:'#4BAC7D'}}>
                {generarCards('P. Buena',valor.PercepBuena, 'Percepción Buena')}
            </Card>           
        </Box>  
        :null}   
    </Box>
    );
}
 